import { rem } from 'polished'
import cn from 'clsx'
import React from 'react'
import styled from 'styled-components'
import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import moment from 'moment/moment'
import ListItem from 'components/Luxkit/List/ListItem'
import AgentAvatar from 'supportAssistant/components/Support/AgentAvatar'
import { AgentType } from 'api/support'

const StyledListItem = styled(ListItem)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.default.five};

  &.is-active {
    background-color: ${({ theme }) => theme.palette.highlight.secondary.light};
  }
`

const Avatar = styled.div`
  grid-column: 1;
  grid-row: 1 / span 2;
  width: ${rem(24)};
  height: ${rem(24)};
  align-self: start;
`

interface Props {
  id?: string;
  title: string;
  chatCreatedAt: string;
  lastMessageAt: string;
  isActive?: boolean;
  onClick: () => void;
  agentType?: AgentType;
}

function ChatPreview({
  title,
  chatCreatedAt,
  lastMessageAt,
  isActive,
  onClick,
  agentType,
}: Props) {
  return (
    <StyledListItem
        startIcon={
          <Avatar>
            {agentType !== AgentType.AGENT && <LuxuryEscapesSmallLogo height={24} width={24} />}
            {agentType === AgentType.AGENT && <AgentAvatar width={24} height={24} />}
          </Avatar>
        }
        title={title}
        subtitle={`Last updated at ${moment(lastMessageAt || chatCreatedAt).format('h:mma D MMM')}`}
        className={cn({ 'is-active': isActive })}
        onClick={onClick}
    />
  )
}

export default ChatPreview
